

  if (!customElements.get('stl-list')) {
    customElements.define(
      'stl-list',
      class StlList extends HTMLElement {
        connectedCallback() {
          /* Scoped to THIS section only, so several Shop the Look sections can live on one page */
          this.hotspots = [...this.querySelectorAll('[data-stl-hotspot]')];
          this.items = [...this.querySelectorAll('[data-stl-item]')];

          this.hotspots.forEach((hotspot) => {
            hotspot.addEventListener('click', () => this.select(hotspot.dataset.stlHotspot));
          });

          this.items.forEach((item) => {
            item.addEventListener('click', (event) => {
              /* Don't steal clicks meant for the dropdown, link or button */
              if (event.target.closest('select, a, button')) return;
              this.select(item.dataset.stlItem);
            });
          });

          this.addEventListener('change', (event) => {
            const select = event.target.closest('[data-stl-variant]');
            if (select) this.onVariantChange(select);
          });

          /* Theme editor: selecting a block highlights it */
          this.addEventListener('shopify:block:select', (event) => {
            const id = event.target.dataset.stlItem;
            if (id) this.select(id);
          });
        }

        select(blockId) {
          this.hotspots.forEach((h) => {
            const active = h.dataset.stlHotspot === blockId;
            h.classList.toggle('is-active', active);
            h.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          this.items.forEach((item) => {
            item.classList.toggle('is-active', item.dataset.stlItem === blockId);
          });
        }

        onVariantChange(select) {
          const item = select.closest('[data-stl-item]');
          const option = select.options[select.selectedIndex];
          const button = item.querySelector('.cpg-add');
          const label = button.querySelector('.cpg-add__label') || button;
          const priceEl = item.querySelector('[data-stl-price]');
          const available = option.dataset.available === 'true';

          button.dataset.variantId = option.value;
          button.disabled = !available;
          if (button.dataset.loading !== 'true') {
            label.textContent = available ? '+ Add' : 'Sold Out';
          }

          if (priceEl) priceEl.textContent = option.dataset.price;

          this.select(item.dataset.stlItem);
        }
      }
    );
  }

  /* ---------- Global .cpg-add handler (shared with cart-upsell + video slider) ----------
     Guarded by window.cpgLoaded so it only runs once per page. */
  (() => {
    if (window.cpgLoaded) return;
    window.cpgLoaded = true;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    async function notifyTheme(cart, variantId, productId) {
      /* 1. Horizon native event */
      try {
        const { CartAddEvent } = await import('@theme/events');
        document.dispatchEvent(
          new CartAddEvent({}, String(variantId), {
            source: 'cpg-add',
            itemCount: cart.item_count || 0,
            productId: String(productId || ''),
            didError: false
          })
        );
        return;
      } catch (error) {
        /* not Horizon's @theme/events — try the fallback below */
      }

      /* 2. Fallback: CartLinesUpdateEvent */
      try {
        const { CartLinesUpdateEvent } = await import('@shopify/events');
        const deferred = CartLinesUpdateEvent.createPromise();

        let horizonCart;
        try {
          horizonCart = CartLinesUpdateEvent.createCartFromAjaxResponse(cart);
        } catch (error) {
          horizonCart = { totalQuantity: cart.item_count || 0, items: cart.items || [] };
        }

        document.dispatchEvent(new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(variantId), quantity: 1 }],
          promise: deferred.promise
        }));

        deferred.resolve({
          cart: horizonCart,
          detail: { items: cart.items || [], itemCount: cart.item_count || 0, source: 'cpg-add', didError: false }
        });
      } catch (error) {
        console.warn('Horizon cart event unavailable', error);
      }
    }

    /* 3. Section refresh (only runs if these IDs exist on the page) */
    async function refreshSections() {
      const sectionIds = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text'];
      await Promise.all(sectionIds.map(async (sectionId) => {
        const current = document.getElementById(sectionId);
        if (!current) return;
        try {
          const res = await fetch(root + '?section_id=' + sectionId);
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.getElementById(sectionId);
          if (fresh) current.innerHTML = fresh.innerHTML;
        } catch (error) {
          console.warn('Cart section update failed', error);
        }
      }));
    }

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('.cpg-add[data-variant-id]:not(:disabled)');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      if (button.dataset.loading === 'true') return;
      button.dataset.loading = 'true';

      const label = button.querySelector('.cpg-add__label') || button;
      const originalText = label.textContent;
      label.textContent = 'Adding...';

      try {
        const variantId = button.dataset.variantId;

        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        });

        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Add to cart failed');

        const productId = data.items && data.items[0] ? data.items[0].product_id : '';

        const cartResponse = await fetch(root + 'cart.js');
        const cart = await cartResponse.json();

        await notifyTheme(cart, variantId, productId);
        await refreshSections();

        label.textContent = 'Added';
        setTimeout(() => {
          label.textContent = originalText;
          button.dataset.loading = 'false';
        }, 1200);
      } catch (error) {
        console.error('cpg add to cart error:', error);
        label.textContent = error.message && error.message !== 'Add to cart failed' ? error.message : 'Try again';
        setTimeout(() => {
          label.textContent = originalText;
          button.dataset.loading = 'false';
        }, 2000);
      }
    }, true);
  })();






  (() => {
    function initSlider(panel) {
      if (!panel || panel.dataset.vpsSliderReady === 'true') return;
      const track = panel.querySelector('[data-vps-track]');
      if (!track) return;

      const pages = Array.from(track.querySelectorAll('.vps__page'));
      if (pages.length < 2) return;
      panel.dataset.vpsSliderReady = 'true';

      const prev = panel.querySelector('[data-vps-prev]');
      const next = panel.querySelector('[data-vps-next]');
      const dots = Array.from(panel.querySelectorAll('[data-vps-dot]'));

      const offsetOf = (i) => pages[i].offsetLeft - pages[0].offsetLeft;

      const currentIndex = () => {
        const x = track.scrollLeft;
        let idx = 0;
        let best = Infinity;
        pages.forEach((page, i) => {
          const d = Math.abs(offsetOf(i) - x);
          if (d < best) { best = d; idx = i; }
        });
        return idx;
      };

      const goTo = (i) => {
        const target = Math.max(0, Math.min(pages.length - 1, i));
        track.scrollTo({ left: offsetOf(target) });
      };

      const update = () => {
        if (panel.hidden) return;
        const i = currentIndex();
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === pages.length - 1;
        dots.forEach((dot, j) => dot.setAttribute('aria-current', j === i ? 'true' : 'false'));
      };

      prev && prev.addEventListener('click', () => goTo(currentIndex() - 1));
      next && next.addEventListener('click', () => goTo(currentIndex() + 1));
      dots.forEach((dot) => dot.addEventListener('click', () => goTo(Number(dot.dataset.vpsDot))));

      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', update);

      panel.vpsUpdate = update;
      update();
    }

    function initVPS(root) {
      if (!root || root.dataset.vpsReady === 'true') return;
      root.dataset.vpsReady = 'true';

      const tabs = Array.from(root.querySelectorAll('[data-vps-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-vps-panel]'));

      const activate = (id, focus) => {
        tabs.forEach((tab) => {
          const on = tab.dataset.vpsTab === id;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          if (on) {
            if (focus) tab.focus();
            tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        });
        panels.forEach((panel) => {
          const on = panel.dataset.vpsPanel === id;
          panel.hidden = !on;
          if (on) {
            initSlider(panel);
            const track = panel.querySelector('[data-vps-track]');
            if (track) track.scrollLeft = 0;
            if (panel.vpsUpdate) panel.vpsUpdate();
          }
        });
      };

      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activate(tab.dataset.vpsTab));
        tab.addEventListener('keydown', (e) => {
          let to = null;
          if (e.key === 'ArrowRight') to = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft') to = (i - 1 + tabs.length) % tabs.length;
          if (e.key === 'Home') to = 0;
          if (e.key === 'End') to = tabs.length - 1;
          if (to === null) return;
          e.preventDefault();
          activate(tabs[to].dataset.vpsTab, true);
        });
      });

      root.vpsActivate = activate;

      /* Variant dropdown -> updates Add button + price (prices come from admin via data-*) */
      root.addEventListener('change', (event) => {
        const select = event.target.closest('[data-vps-variant]');
        if (!select) return;

        const card = select.closest('[data-vps-card]');
        const option = select.options[select.selectedIndex];
        const button = card.querySelector('.cpg-add');
        const label = button.querySelector('.cpg-add__label') || button;
        const priceEl = card.querySelector('[data-vps-price]');
        const compareEl = card.querySelector('[data-vps-compare]');
        const available = option.dataset.available === 'true';

        button.dataset.variantId = option.value;
        button.disabled = !available;
        if (button.dataset.loading !== 'true') {
          label.textContent = available ? '+ Add' : 'Sold out';
        }

        if (priceEl) priceEl.textContent = option.dataset.price;
        if (compareEl) {
          compareEl.textContent = option.dataset.compare || '';
          compareEl.hidden = !option.dataset.compare;
        }
      });

      const firstVisible = panels.find((p) => !p.hidden);
      if (firstVisible) initSlider(firstVisible);
    }

    document.querySelectorAll('[data-vps]').forEach(initVPS);

    if (!window.vpsEditorBound) {
      window.vpsEditorBound = true;
      document.addEventListener('shopify:section:load', (event) => {
        initVPS(event.target.querySelector('[data-vps]'));
      });
      /* Clicking a tab block in the theme editor opens that tab */
      document.addEventListener('shopify:block:select', (event) => {
        const root = event.target.closest('[data-vps]');
        if (root && root.vpsActivate && event.target.dataset.vpsTab) {
          root.vpsActivate(event.target.dataset.vpsTab);
        }
      });
    }
  })();

  /* ---------- Global .cpg-add handler (same as your cart-upsell snippet) ----------
     Guarded by window.cpgLoaded, so it only runs once even if the snippet
     or theme.liquid also includes it. */
  (() => {
    if (window.cpgLoaded) return;
    window.cpgLoaded = true;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    async function notifyTheme(cart, variantId, productId) {
      try {
        const { CartAddEvent } = await import('@theme/events');
        document.dispatchEvent(
          new CartAddEvent({}, String(variantId), {
            source: 'cpg-add',
            itemCount: cart.item_count || 0,
            productId: String(productId || ''),
            didError: false
          })
        );
        return;
      } catch (error) {
        /* not Horizon's @theme/events — try the fallback below */
      }

      try {
        const { CartLinesUpdateEvent } = await import('@shopify/events');
        const deferred = CartLinesUpdateEvent.createPromise();

        let horizonCart;
        try {
          horizonCart = CartLinesUpdateEvent.createCartFromAjaxResponse(cart);
        } catch (error) {
          horizonCart = { totalQuantity: cart.item_count || 0, items: cart.items || [] };
        }

        document.dispatchEvent(new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(variantId), quantity: 1 }],
          promise: deferred.promise
        }));

        deferred.resolve({
          cart: horizonCart,
          detail: { items: cart.items || [], itemCount: cart.item_count || 0, source: 'cpg-add', didError: false }
        });
      } catch (error) {
        console.warn('Horizon cart event unavailable', error);
      }
    }

    async function refreshSections() {
      const sectionIds = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text'];
      await Promise.all(sectionIds.map(async (sectionId) => {
        const current = document.getElementById(sectionId);
        if (!current) return;
        try {
          const res = await fetch(root + '?section_id=' + sectionId);
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.getElementById(sectionId);
          if (fresh) current.innerHTML = fresh.innerHTML;
        } catch (error) {
          console.warn('Cart section update failed', error);
        }
      }));
    }

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('.cpg-add[data-variant-id]:not(:disabled)');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      if (button.dataset.loading === 'true') return;
      button.dataset.loading = 'true';

      const label = button.querySelector('.cpg-add__label') || button;
      const originalText = label.textContent;
      label.textContent = 'Adding...';

      try {
        const variantId = button.dataset.variantId;

        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        });

        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Add to cart failed');

        const productId = data.items && data.items[0] ? data.items[0].product_id : '';

        const cartResponse = await fetch(root + 'cart.js');
        const cart = await cartResponse.json();

        await notifyTheme(cart, variantId, productId);
        await refreshSections();

        label.textContent = 'Added';
        setTimeout(() => {
          label.textContent = originalText;
          button.dataset.loading = 'false';
        }, 1200);
      } catch (error) {
        console.error('cpg add to cart error:', error);
        label.textContent = originalText;
        button.dataset.loading = 'false';
      }
    }, true);
  })();



  
  if (!customElements.get('video-product-reels')) {
    customElements.define(
      'video-product-reels',
      class VideoProductReels extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.vpr__track');
          this.videos = [...this.querySelectorAll('video')];

          // Autoplay only while visible
          this.videos.forEach((v) => {
            v.muted = true;
            v.playsInline = true;
            v.setAttribute('playsinline', '');
            v.removeAttribute('controls');
          });
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach(({ target, isIntersecting }) => {
                if (isIntersecting) target.play().catch(() => {});
                else target.pause();
              });
            },
            { threshold: 0.5 }
          );
          this.videos.forEach((v) => this.observer.observe(v));

          // Sound toggle — only one video unmuted at a time
          this.querySelectorAll('.vpr__sound').forEach((btn) => {
            btn.addEventListener('click', () => {
              const video = btn.parentElement.querySelector('video');
              const unmute = video.muted;
              this.querySelectorAll('.vpr__sound').forEach((b) => {
                const v = b.parentElement.querySelector('video');
                v.muted = true;
                b.setAttribute('aria-pressed', 'false');
                b.setAttribute('aria-label', 'Unmute video');
              });
              if (unmute) {
                video.muted = false;
                video.play().catch(() => {});
                btn.setAttribute('aria-pressed', 'true');
                btn.setAttribute('aria-label', 'Mute video');
              }
            });
          });

          // Arrows
          this.prev = this.querySelector('.vpr__arrow--prev');
          this.next = this.querySelector('.vpr__arrow--next');
          [this.prev, this.next].forEach((btn) =>
            btn?.addEventListener('click', () => {
              const item = this.track.querySelector('.vpr__item');
              const step = item ? item.getBoundingClientRect().width + 12 : 300;
              this.track.scrollBy({ left: step * Number(btn.dataset.dir), behavior: 'smooth' });
            })
          );
          this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
          window.addEventListener('resize', () => this.updateArrows());
          this.updateArrows();
        }

        updateArrows() {
          if (!this.prev || !this.next) return;
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          this.prev.disabled = this.track.scrollLeft <= 2;
          this.next.disabled = this.track.scrollLeft >= max;
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }

  if (!customElements.get('video-product-add')) {
    customElements.define(
      'video-product-add',
      class VideoProductAdd extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('.cpg-add');
          this.label = this.button?.querySelector('.cpg-add__label');
          this.variantSelect = this.querySelector('[data-role="variant"]');
          this.card = this.closest('.vpr-card');
          this.priceEl = this.card?.querySelector('.vpr-card__sale');

          this.variantSelect?.addEventListener('change', () => {
            const opt = this.variantSelect.selectedOptions[0];
            if (!opt || !this.button) return;

            const available = opt.dataset.available === 'true';
            this.button.dataset.variantId = opt.value;
            this.button.disabled = !available;
            if (this.label && this.button.dataset.loading !== 'true') {
              this.label.textContent = available ? '+ Add' : 'Sold out';
            }

            if (this.priceEl && opt.dataset.price) this.priceEl.textContent = opt.dataset.price;
          });
        }
      }
    );
  }


  (() => {
    if (window.cpgLoaded) return;
    window.cpgLoaded = true;

    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    async function notifyTheme(cart, variantId, productId) {
      /* 1. Horizon native event */
      try {
        const { CartAddEvent } = await import('@theme/events');
        document.dispatchEvent(
          new CartAddEvent({}, String(variantId), {
            source: 'cpg-add',
            itemCount: cart.item_count || 0,
            productId: String(productId || ''),
            didError: false
          })
        );
        return;
      } catch (error) {
        /* not Horizon's @theme/events — try the fallback below */
      }

      /* 2. Fallback: CartLinesUpdateEvent */
      try {
        const { CartLinesUpdateEvent } = await import('@shopify/events');
        const deferred = CartLinesUpdateEvent.createPromise();

        let horizonCart;
        try {
          horizonCart = CartLinesUpdateEvent.createCartFromAjaxResponse(cart);
        } catch (error) {
          horizonCart = { totalQuantity: cart.item_count || 0, items: cart.items || [] };
        }

        document.dispatchEvent(new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(variantId), quantity: 1 }],
          promise: deferred.promise
        }));

        deferred.resolve({
          cart: horizonCart,
          detail: { items: cart.items || [], itemCount: cart.item_count || 0, source: 'cpg-add', didError: false }
        });
      } catch (error) {
        console.warn('Horizon cart event unavailable', error);
      }
    }

    /* 3. Section refresh (only runs if these IDs exist on the page) */
    async function refreshSections() {
      const sectionIds = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text'];
      await Promise.all(sectionIds.map(async (sectionId) => {
        const current = document.getElementById(sectionId);
        if (!current) return;
        try {
          const res = await fetch(root + '?section_id=' + sectionId);
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.getElementById(sectionId);
          if (fresh) current.innerHTML = fresh.innerHTML;
        } catch (error) {
          console.warn('Cart section update failed', error);
        }
      }));
    }

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('.cpg-add[data-variant-id]:not(:disabled)');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      if (button.dataset.loading === 'true') return;
      button.dataset.loading = 'true';

      const label = button.querySelector('.cpg-add__label') || button;
      const originalText = label.textContent;
      label.textContent = 'Adding...';

      try {
        const variantId = button.dataset.variantId;

        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        });

        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Add to cart failed');

        const productId = data.items && data.items[0] ? data.items[0].product_id : '';

        const cartResponse = await fetch(root + 'cart.js');
        const cart = await cartResponse.json();

        await notifyTheme(cart, variantId, productId);
        await refreshSections();

        label.textContent = 'Added';
        setTimeout(() => {
          label.textContent = originalText;
          button.dataset.loading = 'false';
        }, 1200);
      } catch (error) {
        console.error('cpg add to cart error:', error);
        label.textContent = error.message && error.message !== 'Add to cart failed' ? error.message : 'Try again';
        setTimeout(() => {
          label.textContent = originalText;
          button.dataset.loading = 'false';
        }, 2000);
      }
    }, true);
  })();






